// 側邊選單 社群連結

import { OFFICIAL_URL } from '@/common/constant';
import Image from 'next/image';

// 社群
const social = [
    {
        title: 'facebook',
        link: OFFICIAL_URL.FACEBOOK,
    },
    {
        title: 'instagram',
        link: OFFICIAL_URL.INSTAGRAM,
    },
    {
        title: 'threads',
        link: OFFICIAL_URL.THREADS,
    },
];

const MenuSocial = ({ t, showMenu }) => {
    return (
        <div
            className={`space-y-[12px] text-center ${
                showMenu
                    ? 'w-[173px]'
                    : 'ulg:between-center ulg:gap-x-[4px] ulg:space-y-0 ulg:[&>*]:w-[calc((100%-8px)/3)]'
            } ulg:!w-[unset] ulg:between-center ulg:gap-x-[4px] ulg:space-y-0 ulg:[&>*]:w-[calc((100%-8px)/3)]`}
        >
            {showMenu && <p className="text-btn2 text-black6 ulg:hidden">{t('SOCIAL')}</p>}

            {/* 社群連結 */}
            {social.map((v, i) => (
                <a
                    key={v.title + 'aside' + i}
                    href={v.link}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="px-[12px] py-[10px] flex rounded-[4px] group items-center gap-x-[5px] justify-start border-1 border-black1 relative
                    [&>p]:absolute [&>p]:top-0 [&>p]:left-0 [&>p]:w-full [&>p]:h-full [&>p]:z-[-1] [&>p]:trans [&>p]:opacity-0 ulg:justify-center"
                >
                    {/* icon */}
                    <Image
                        className="w-[22px] aspect-[1] trans group-hover:filter-white ulg:w-[40px]"
                        width={22}
                        height={22}
                        src={`/images/icon/icon_${v.title}.svg`}
                        alt="icon"
                    />
                    <span
                        className={`text-btn1 text-black4 trans group-hover:text-white ${
                            showMenu ? '' : 'hidden'
                        } ulg:hidden`}
                    >
                        {t(v.title.toUpperCase())}
                    </span>

                    <p className='bg-[url("/images/icon/icon_filter.svg")] bg-cover bg-center group-hover:opacity-[1]' />
                    <p className="bg-loa group-hover:opacity-[.8]" />
                </a>
            ))}
        </div>
    );
};

export default MenuSocial;
